import { render, staticRenderFns } from "./CalloutCard.vue?vue&type=template&id=63b0e79c&scoped=true&"
import script from "./CalloutCard.vue?vue&type=script&lang=ts&"
export * from "./CalloutCard.vue?vue&type=script&lang=ts&"
import style0 from "./CalloutCard.vue?vue&type=style&index=0&id=63b0e79c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b0e79c",
  null
  
)

export default component.exports